var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hideSection
    ? _c("div", { staticClass: "buy-in-store" }, [
        _c("div", { attrs: { id: "pear-pdp-target" } })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }